import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { signOut, type SignedInOwner } from "../api.js";
import { Lockup } from "../components/Logo.js";

/** The owner's frame: who you are, where you are, and the way out. */
export function OwnerShell({
  owner,
  children,
}: {
  owner: SignedInOwner;
  children: ReactNode;
}) {
  const queryClient = useQueryClient();
  const endSession = useMutation({
    mutationFn: signOut,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["session"] }),
  });

  return (
    <main className="page">
      <header className="bar">
        <Lockup size={22} />
        <nav className="nav">
          <NavLink to="/connections">Connections</NavLink>
          <NavLink to="/availability">Availability</NavLink>
          <NavLink to="/calendar">Calendar</NavLink>
          <NavLink to="/requests">Requests</NavLink>
          <NavLink to="/invitations">Access</NavLink>
        </nav>
        <div className="who">
          <span>{owner.fullName}</span>
          <span className="mono">{owner.email}</span>
        </div>
        <button
          type="button"
          className="ghost"
          onClick={() => endSession.mutate()}
          disabled={endSession.isPending}
        >
          Sign out
        </button>
      </header>
      {children}
    </main>
  );
}
